export const COOKIE_CATEGORY = {
  STRICTLY_NECESSARY: 'strict',
  PERFORMANCE: 'performance',
  FUNCTIONAL: 'functionality',
  TARGETING: 'targeting',
  UNCLASSIFIED: 'unclassified'
}

export const COOKIE_CATEGORY_TITLE_BY_COOKIE_CATEGORY = {
  [COOKIE_CATEGORY.STRICTLY_NECESSARY]: 'Strictly Necessary',
  [COOKIE_CATEGORY.PERFORMANCE]: 'Performance',
  [COOKIE_CATEGORY.FUNCTIONAL]: 'Functional',
  [COOKIE_CATEGORY.TARGETING]: 'Targeting'
}

export const MAIN_COOKIE_CATEGORY_VALUES = [
  COOKIE_CATEGORY.STRICTLY_NECESSARY,
  COOKIE_CATEGORY.PERFORMANCE,
  COOKIE_CATEGORY.FUNCTIONAL,
  COOKIE_CATEGORY.TARGETING,
  COOKIE_CATEGORY.UNCLASSIFIED
]

export const COOKIE_ENTITY_TYPE = {
  RE_CAPTCHA: 'RE_CAPTCHA',
  BLUE_SNAP: 'BLUE_SNAP'
}

/**
 * Full list of prior blocked services
 */
export const REQUIRED_COOKIE_CATEGORIES_BY_COOKIE_ENTITY_TYPE = {
  [COOKIE_ENTITY_TYPE.RE_CAPTCHA]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.BLUE_SNAP]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.PERFORMANCE,
    COOKIE_CATEGORY.UNCLASSIFIED
  ]
}

export const CMP_CONSENT_COOKIE_NAME = 'CookieScriptConsent'

export const HANDLER_TYPE = {
  GLOBAL: 'global',
  LOCAL: 'local'
}

export const HANDLER_TYPE_BY_ENTITY_TYPE = {
  [COOKIE_ENTITY_TYPE.RE_CAPTCHA]: HANDLER_TYPE.GLOBAL
}

export const CMP_POPUP_WRAPPER_ID = 'cookiescript_injected_wrapper'

export const CMP_STATE = {
  CA: 'ca'
}

export const CMP_CCPA_CONTACT_US_LINK_TEXT =
  'Do Not Sell or Share My Personal Information'
